import { getEventLabel } from 'Modules/reports/views/main/components/reportsTab/.components/eventReport';

export const searchableColumnKeys = [
    'label', 'eventName', 'driverName', 'driverDefault', 'address', 'vin',
    'displayOdometer', 'engineHours', 'speed', 'speedLimit', 'make', 'model',
    'year', 'esn', 'imei', 'videoDevices', 'starterSupported'
];

export const getSearchPlaceholder = (columns = [], messages = {}) => {
    const fields = searchableColumnKeys
        .map(key => columns.find(column => column.key === key)?.title)
        .filter(Boolean)
        .join(', ');

    return fields ? messages['fleetView_search'].replace('{fields}', fields) : '';
};

export const getEventSearchValue = (item, messages) => {
    if (!item?.eventName) return '';
    return `${item.eventName} ${getEventLabel(item.eventName, messages)}`;
};

export const getVinSearchValue = (item) => (item?.useEcuVin ? item?.ecuVin : item?.vin) || '';

export const getLinkedDeviceSearchValue = (item) => {
    const { esn, manufacturer } = item?.videoDevices?.[0] || {};
    return [esn, manufacturer].filter(Boolean).join(' ');
};
